
define('text!views/shell.html',[],function () { return '<div class="atn-shell" data-bind="router: {cacheViews:false}, atnRouterViewFix: router"></div>';});

